import GrantAndRevokePermissions from './admin-action-forms/GrantAndRevokePermissions';
import UpdateUserKarma from './admin-action-forms/UpdateUserKarma';
import ViewPermissions from './admin-action-forms/ViewPermissions';
import BlockUnblockAgent from './admin-action-forms/BlockUnblockAgent';
import TestTatPolicy from './admin-action-forms/TestTatPolicy';
import CreateUpdateAgent from './admin-action-forms/CreateUpdateAgent';
import DefaultComp from './admin-action-forms/DefaultComp';
import UpdateCXEmail from './admin-action-forms/UpdateUserEmail';
import UpdateAgentEmail from './admin-action-forms/UpdateAgentEmail';
import { HelpDeskAdmin } from './admin-action-forms/HelpDeskAdmin/HelpDeskAdmin';
import UpdateAgentLimit from './admin-action-forms/UpdateAgentLimit';
import BlockUnblockDevice from './admin-action-forms/BlockUnblockDevice';
import UpdateInvoice from './admin-action-forms/UpdateInvoice';
import Announcements from './admin-action-forms/CrmAnnouncements';
import ReturnConfigDashboard from './admin-action-forms/ReturnConfigDashboard/Dashboard';
import DelayDaillers from './admin-action-forms/DelayDiallers/DelayDaillers';
import AdonpDashboard from './admin-action-forms/ADONP/AdonpDashboard';
import BulkMarkFraud from './admin-action-forms/bulk-fraud-marking/BulkFraudMarking';
import UnmarkFraud from './admin-action-forms/unmark-fraud/UnmarkFraud';
import ComplaintTypePolicy from './admin-action-forms/ComplaintTypePolicy/ComplaintTypePolicy';
import PickupPolicy from './admin-action-forms/PickupPolicy/PickupPolicy';
import OutOfBusinessHoursQueue from './admin-action-forms/OutOfBusinessHoursQueue/OutOfBusinessHoursQueue';
import PromosAndCoupons from './admin-action-forms/PromoAndCoupons/PromoAndCoupons';
import ViewUpdateDeleteSops from './admin-action-forms/SopManagement/ViewUpdateDeleteSops';
import CreateSops from './admin-action-forms/SopManagement/CreateSops';
import RiderMisconductConfig from './admin-action-forms/RiderMisconductConfig/RiderMisconductConfig';
import AdminActionsDashboard from './admin-action-forms/AdminActionsDashboard/AdminActionsDashboard';
import IvaPolicies from './admin-action-forms/IvaPolicies/IvaPolicies';

export const links = {
  GRANT_REVOKE_ACCESS: GrantAndRevokePermissions,
  VIEW_PERMISSIONS: ViewPermissions,
  MANAGE_DASHBOARD: DefaultComp,
  UPDATE_KARMA: UpdateUserKarma,
  BLOCK_UNBLOCK_AGENT: BlockUnblockAgent,
  TAT_TEST_POLICY: TestTatPolicy,
  CREATE_UPDATE_AGENT: CreateUpdateAgent,
  CREATE_PROMOS: PromosAndCoupons,
  MIGRATE_AGENT_EMAIL_MAPPING: UpdateAgentEmail,
  CX_EMAIL_UPDATE: UpdateCXEmail,
  CUSTOMER_HELPDESK: HelpDeskAdmin,
  RIDER_HELPDESK: HelpDeskAdmin,
  UPDATE_AGENT_LIMIT: UpdateAgentLimit,
  BLOCK_UNBLOCK_DEVICE: BlockUnblockDevice,
  UPDATE_INVOICE: UpdateInvoice,
  ADD_UPDATE_ANNOUNCEMENTS: Announcements,
  RETURN_CONFIG_OVERVIEW: ReturnConfigDashboard,
  DELAY_DIALLERS: DelayDaillers,
  ADONP: AdonpDashboard,
  BULK_MARK_FRAUD: BulkMarkFraud,
  BULK_UNMARK_FRAUD: UnmarkFraud,
  COMPLAINT_TYPE_POLICY: ComplaintTypePolicy,
  PICKUP_POLICY: PickupPolicy,
  QUEUE_BUSINESS_HOURS: OutOfBusinessHoursQueue,
  UPDATE_DELETE_SOPS: ViewUpdateDeleteSops,
  CREATE_SOPS: CreateSops,
  RIDER_MISCONDUCT_CONFIG: RiderMisconductConfig,
  // Key is the backend-provided tab slug (do not rename); component is the Admin Actions Dashboard.
  COMMON_ACTION_DASHBOARD: AdminActionsDashboard,
  IVA_POLICIES: IvaPolicies,
};
